import React from 'react';

import Reliance from '../assets/images/brands/reliance.jpg'
import UPL from '../assets/images/brands/upl.jpeg';
import BankSathi from '../assets/images/brands/banksathi.png';
import Samunnati from '../assets/images/brands/samunnati.png';
import Chambal from '../assets/images/brands/chambal.png';
import JumboContainer from './common/JumboContainer';
import KrishiTantra from '../assets/images/brands/krishitantra.png';

import '../styles/Partner.css';
import { useTranslation } from 'react-i18next';
import { PARTNER_EYEBROW, PARTNER_LABEL, PARTNER_DESCRIPTION } from '../data/i18n/partner';

const businessPartners = [
  {
    name: 'UPL',
    image: UPL,
    link: 'https://www.upl-ltd.com/in'
  },
  {
    name: 'Reliance Retail',
    image: Reliance,
    link: 'https://relianceretail.com',
  },
  {
    name: 'KrishiTantra',
    image: KrishiTantra,
    link: 'https://krishitantra.com/'
  },
  {
    name: 'Samunnati',
    image: Samunnati,
    link: 'https://samunnati.com/'
  },
  {
    name: 'Chambal Fertilizers',
    image: Chambal,
    link: 'http://chambalfertilisers.com/'
  },
  {
    name: 'Bank Sathi',
    image: BankSathi,
    link: 'https://www.banksathi.com/'
  }
]

const marqueePartners = [...businessPartners, ...businessPartners];

const Partners = () => {

  const {t} = useTranslation();

  return (
    <JumboContainer id="partner" eyebrow={t(PARTNER_EYEBROW)} title={t(PARTNER_LABEL)} subtitle={t(PARTNER_DESCRIPTION)}>
      <div className="partners-network" aria-hidden="true">
        <svg viewBox="0 0 1400 700" preserveAspectRatio="xMidYMid slice">
          <g stroke="rgba(15, 120, 100, 0.15)" strokeWidth="1">
            <line x1="120" y1="90" x2="340" y2="220" />
            <line x1="340" y1="220" x2="230" y2="410" />
            <line x1="340" y1="220" x2="560" y2="140" />
            <line x1="560" y1="140" x2="760" y2="260" />
            <line x1="230" y1="410" x2="480" y2="520" />
            <line x1="480" y1="520" x2="760" y2="260" />
            <line x1="760" y1="260" x2="1000" y2="150" />
            <line x1="760" y1="260" x2="980" y2="420" />
            <line x1="980" y1="420" x2="1230" y2="330" />
            <line x1="1000" y1="150" x2="1230" y2="330" />
            <line x1="1230" y1="330" x2="1340" y2="540" />
            <line x1="980" y1="420" x2="1120" y2="600" />
            <line x1="480" y1="520" x2="700" y2="640" />
          </g>
          <g fill="#0f9045">
            <circle cx="120" cy="90" r="4" />
            <circle cx="340" cy="220" r="5" />
            <circle cx="230" cy="410" r="4" />
            <circle cx="560" cy="140" r="4" />
            <circle cx="760" cy="260" r="6" />
            <circle cx="480" cy="520" r="4" />
            <circle cx="1000" cy="150" r="4" />
            <circle cx="980" cy="420" r="5" />
            <circle cx="1230" cy="330" r="4" />
            <circle cx="1340" cy="540" r="4" />
            <circle cx="1120" cy="600" r="4" />
            <circle cx="700" cy="640" r="4" />
          </g>
          <g fill="#0f9045" opacity="0.18">
            <circle cx="760" cy="260" r="14" />
            <circle cx="340" cy="220" r="11" />
            <circle cx="980" cy="420" r="11" />
          </g>
        </svg>
      </div>

      <div className="marquee-wrap">
        <div className="marquee-track">
          {marqueePartners.map((partner, index) => (
            <a
              href={partner.link}
              target="_blank"
              rel="noreferrer"
              className="partner-card"
              key={`${partner.name}-${index}`}
            >
              <img
                className="partner-img"
                src={partner.image}
                alt={partner.name}
              />
            </a>
          ))}
        </div>
      </div>
    </JumboContainer>
  )

}

export default Partners;
